import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import IntlMessages from 'util/IntlMessages';
import { getProjectAccordingToDomain } from 'packages/utils';

import styles from './styles.module.less';

const TITLE_IDS = {
  h1: 'app-brand-title',
  h2: 'app-brand-subtitle',
};

export default function AppBrand({
  children,
  className,
  placement = 'vertical',
  titleAs = 'div',
  authHero = false,
}) {
  const brandValues = getProjectAccordingToDomain();
  const TitleTag = titleAs;
  const titleId = TITLE_IDS[titleAs] ?? undefined;

  const placementType = {
    horizontal: 'gx-flex-row gx-justify-content-center',
    vertical: 'gx-flex-column gx-align-items-center',
  };

  return (
    <div
      className={classNames(
        styles.titleContainer,
        authHero && styles.authHero,
        className,
        placementType[placement],
      )}
    >
      <div className={brandValues.project === 'operonda' ? styles.logo : styles.logoGuarnic}>
        <img src={brandValues.logo} alt="" />
      </div>
      <TitleTag id={titleId} className={classNames('gx-guarnic-headline-1', authHero && styles.authHeadline)}>
        {children ?? (
          <IntlMessages id="auth.login.to" values={{ text: brandValues.title }} />
        )}
      </TitleTag>
    </div>
  );
}

AppBrand.propTypes = {
  authHero: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  placement: PropTypes.oneOf(['horizontal', 'vertical']),
  titleAs: PropTypes.oneOf(['div', 'h1', 'h2']),
};
